<div class="row">
  <div class="col-md-12">
    <div class="login_page">
      <section class="register">
        <div class="modal-header close_btn_align" style="margin: 15px 15px 0px 0px">
          <button type="button" class="btn-close btn-close-black" data-bs-dismiss="modal" (click)="closeModal()"></button>
        </div>
        <div class="justify-content-center ng-star-inserted">
          <div class="position-relative" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%">
              <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 18px">
                <span
                  style="
                    background: #4bb543;
                    border-radius: 50%;
                    width: 48px;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
              </div>
              <div style="font-size: 1.25rem; font-weight: 600; margin-bottom: 10px; color: #222; text-align: center">
                Thanks for connecting!
              </div>
              <div style="font-size: 1rem; color: #555; margin-bottom: 18px; text-align: center">
                An IITian & NEET Expert will guide you shortly.
              </div>
              <button
                type="button"
                class="btn-cms-valid"
                style="
                  background: #ff6a0b;
                  color: #fff;
                  border-radius: 6px;
                  padding: 8px 24px;
                  font-weight: 500;
                  border: none;
                  display: block;
                  margin: 0 auto;
                "
                (click)="closeModal()"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
